export const releasesTableColumns = [
    {
      key: "check",
      display_name: "",
      cellStyles: {
        "font-size": "13px",
      },
      headerStyles: {
        background: "#7593F2",
        "font-weight": "600",
        borderRadius: "6px 0 0",
        width: "5%",
        color: "#fff",
      },
      _config: {
        type: "checkbox",
        displayInColumn: false,
      },
    },
    {
      key: "name",
      display_name: "Release Name",
      cellStyles: {
        "font-size": "13px",
      },
      headerStyles: {
        background: "#7593F2",
        
        "font-weight": "600",
        width: "20%",
        color: "#fff",
      },
    },
    {
      key: "description",
      display_name: "Description",
      cellStyles: { "font-size": "13px" },
      headerStyles: {
        background: "#7593F2",
        
        "font-weight": "600",
        width: "30%",
        color: "#fff",
      },
    },
    {
      key: "startDate",
      display_name: "Start Date",
      cellStyles: { "font-size": "13px" },
      headerStyles: {
        background: "#7593F2",
        color: "#fff",
        
        "font-weight": "600",
        width: "15%",
      },
      _config: {
        displayInColumn: false,
        type: "date",
        isClickable: "true",
      },
    },
    {
      key: "releaseDate",
      display_name: "Release Date",
      cellStyles: { "font-size": "13px" },
      headerStyles: {
        background: "#7593F2",
        
        "font-weight": "600",
        width: "15%",
        color: "#fff",
      },
      _config: {
        displayInColumn: false,
        type: "date",
        isClickable: "true",
      },
    },
    {
      key: "edit",
      display_name: "",
      cellStyles: { "font-size": "13px" },
      headerStyles: {
        background: "#7593F2",
        borderRadius: "0 6px 0 0",
        "font-weight": "600",
        width: "6%",
        color: "#fff",
      },
      _config: {
        displayInColumn: false,
        type: "svg",
        value: "../../../../assets/images/table/table-item-edit.svg",
        isClickable: "true",
      },
    },
  ];